module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap/fonts/glyphicons-halflings-regular.svg
// module id = 799
// module chunks = 8